module.exports = __webpack_public_path__ + "img/newspaper.06d4eea2.svg";